export const DOMAIN_HOME = 'https://useragentapi.io/';

export const SIGN_UP = '/sign-up';
export const LOG_IN = '/log-in';
export const PASSWORD_FORGET = '/forget-password';

export const DASHBOARD = '/';
export const ACCOUNT = '/account';
export const SUBSCRIPTION = '/subscription';
